import React, { useEffect } from "react";
import ResellerPage, { EN } from "@/pages/ResellerPage";

export default function ResellerPageEn() {
  useEffect(() => {
    document.documentElement.lang = "en";
    return () => { document.documentElement.lang = "fr"; };
  }, []);
  return <ResellerPage t={EN} />;
}
